// extracted by mini-css-extract-plugin
module.exports = {"mapContainer":"map_mapContainer__6XHXT","contactInfo":"map_contactInfo__RimSC","infoTitle":"map_infoTitle__lZQmd","infoContent":"map_infoContent__D_C4R"};